import isEmpty from 'lodash/isEmpty';
import isEmail from 'validator/lib/isEmail';
import i18n from '../../../i18n';

export const validate = values => {
    let errors = {};

    validateEmail(values, errors);

    return errors;
};

const validateEmail = (values, errors) => {
    const email = values.email;

    if (isEmpty(email)) {
        return errors.email = i18n.t('account.validation_email_not_valid');
    }

    if (!isEmail(email)) {
        return errors.email = i18n.t('account.validation_email_not_valid');
    }
};